import type {
  CreateCohortUseCase,
  GetCohortUseCase,
  ListCohortsUseCase,
  UpdateCohortUseCase,
} from '@/application/port/in/CohortUseCase';
import type {
  CreateCohortCommand,
  ListCohortsQuery,
  UpdateCohortCommand,
} from '@/application/port/in/dto/CohortCommand';
import type { CohortGateway } from '@/application/port/out/CohortGateway';
import type { Cohort } from '@/domain/model/Cohort';
import type { Page } from '@/domain/model/Page';

export class ListCohortsUseCaseImpl implements ListCohortsUseCase {
  constructor(private readonly gateway: CohortGateway) {}

  execute(query: ListCohortsQuery): Promise<Page<Cohort>> {
    return this.gateway.list(query);
  }
}

export class GetCohortUseCaseImpl implements GetCohortUseCase {
  constructor(private readonly gateway: CohortGateway) {}

  execute(id: string): Promise<Cohort> {
    if (!id) return Promise.reject(new Error('ID da turma é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class CreateCohortUseCaseImpl implements CreateCohortUseCase {
  constructor(private readonly gateway: CohortGateway) {}

  execute(command: CreateCohortCommand): Promise<Cohort> {
    return this.gateway.create(command);
  }
}

export class UpdateCohortUseCaseImpl implements UpdateCohortUseCase {
  constructor(private readonly gateway: CohortGateway) {}

  execute(id: string, command: UpdateCohortCommand): Promise<Cohort> {
    return this.gateway.update(id, command);
  }
}
